module.exports = __webpack_public_path__ + "static/media/IMG_034.f2bb4c9a.JPG";